import $ from "jquery";
window.$ = $;

import { Button, Dropdown, Util, Tab, Modal } from 'bootstrap';

import 'slick-carousel';
import 'jquery-match-height';
// // Theme sass
import '../sass/style.scss';

// Import own Javascript
import './js/carousel.js';
import './js/magnific-popup.js';
import './js/fontawesome.js';
import './js/other.js';
import './js/faq.js';
import './js/cf7-stappen.js';
// Import modules

import AOS from 'aos';

$(document).ready(function () {
    AOS.init({
        duration: 1000,
    });
});

// Import SVG images here so webpack converts them and puts them in the public folder

import arrow_left from '../../src/images/btn-prev.svg';
import arrow_right from '../../src/images/btn-next.svg';